<template>
  <div class="license-template">
    <div class="img-wrap">
      <div class="img" :style="diyDom.imgStyle">
        <div class="item" v-show="item.show" v-for="(item, index) in apiData.fields" :key="index">
          <VueDragResize
            :h="item.type == 'image' ? item.height : 1"
            :w="item.width"
            :x="item.x"
            :y="item.y"
            :isResizable="item.type == 'image'"
            @resizing="onResize($event, index, item.type)"
            @dragging="onDrag($event, index, item.type)"
          >
            <div
              v-if="item.type == 'image'"
              class="img-item"
              :style="{ width: `${item.width}px`, height: `${item.height}px` }"
            ></div>
            <span v-else :id="`span${index}`" :style="{ fontSize: `${item.font_size}px` }">
              {{ item.title }}
            </span>
          </VueDragResize>
        </div>
      </div>
      <upload-file-one
        :noPreview="true"
        @on-change="templateChange"
        :path="apiData.template_path"
        :url="apiData.template_url"
        tips="* 上传证书模板"
      ></upload-file-one>
    </div>
    <div class="right" :style="{ height: `${diyDom.imgStyle.height}` }">
      <div class="item" v-for="(item, index) in apiData.fields" :key="index">
        <Divider v-if="index != 0" />
        <div class="item-title">
          <h3>{{ item.title }}</h3>
          <Checkbox v-model="item.show">在证上显示</Checkbox>
        </div>
        <div style="display: flex; justify-content: left">
          <div class="item-info" v-if="item.type == 'text'">
            <span>字号：</span>
            <InputNumber :min="12" placeholder="请输入字体大小" v-model="item.font_size">
              <span slot="append">px</span>
            </InputNumber>
          </div>
          <div class="item-info" style="margin-left:10px">
            <span>X轴：</span>
            <InputNumber  placeholder="请输入X轴" v-model="item.x">
            </InputNumber>
          </div>
          <div class="item-info" style="margin-left:10px">
            <span>Y轴：</span>
            <InputNumber  placeholder="请输入Y轴" v-model="item.y">
            </InputNumber>
          </div>
        </div>
      </div>
      <Button type="primary" @click="submitFn">确定</Button>
      <Button style="margin-left: 10px" @click="$router.go(-1)">取消</Button>
    </div>
  </div>
</template>

<script>
  import * as apiCertificates from '@/api/certificates'
  import uploadFileOne from '@/components/upload-custom/upload-file-one.vue'
  import VueDragResize from 'vue-drag-resize'
  export default {
    name: 'licenseTemplate',
    components: {
      VueDragResize,
      uploadFileOne,
    },
    data() {
      return {
        query: {},
        search: {},
        diyDom: {
          imgWidth: 800,
          imgStyle: {}, // 图片样式
          textStyle: {}, // 文本样式
        },
        diyData: {
          imageInfo: {}, // 证书真实信息
          multiple: 1, // 倍数，图片真实宽高除以css得到的倍数
          fleidsList: [], // 未改造过的fields表单，临时存储
        },
        apiData: {
          fields: [],
          template_url: '', // 模板
          template_path: '',
        },
      }
    },
    methods: {
      // 获取证书模板详情
      getDetail() {
        this.$store.commit('setSpinShow', true)
        apiCertificates
          .apiCertificatesTempDetail(this.query.id)
          .then(res => {
            this.apiData.template_url = res.data.templateData.template_url
            this.apiData.template_path = res.data.templateData.template_path
            this.diyData.fleidsList = res.data.fields
            this.setTemplateImg()
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      // 设置图片模板
      setTemplateImg() {
        this.getImageSize(this.apiData.template_url).then(info => {
          // 图片真实宽高信息
          this.diyData.imageInfo = info
          // 图片真实信息和css宽高倍率
          this.diyData.multiple = info.width / this.diyDom.imgWidth
          let multiple = this.diyData.multiple
          this.apiData.fields = this.diyData.fleidsList.map((item, index) => {
            return {
              ...item,
              x: this.getDefaultXYWH(item).x,
              y: this.getDefaultXYWH(item).y,
              width: this.getDefaultXYWH(item).width,
              height: this.getDefaultXYWH(item).height,
              font_size: parseInt(item.font_size / multiple),
            }
          })
          // 图片样式
          this.diyDom.imgStyle = {
            background: `url(${this.apiData.template_url}) no-repeat`,
            backgroundSize: 'contain',
            width: '800px',
            height: `${info.height / this.diyData.multiple}px`,
          }
        })
      },
      // 模板上传成功
      templateChange(e) {
        this.apiData.template_path = e.path
        this.apiData.template_url = e.url
        this.setTemplateImg()
      },
      // 获取数据后，设置默认值
      getDefaultXYWH(item) {
        let multiple = this.diyData.multiple
        // x轴
        let x = Math.ceil(item.x) / multiple
        if (item.x == '') {
          x = 0
        }
        // y轴
        let y = 0
        if (item.type == 'image') {
          y = Math.ceil(item.y) / multiple
        } else if (item.type == 'text') {
          y = Math.ceil(item.y - Number(item.font_size)) / multiple
        }
        // width
        let width = 300
        if (item.width != 0 && item.width != '' && item.width != null) {
          width = item.width / multiple
        }
        // height
        let height = 200
        if (item.height != 0 && item.height != '' && item.height != null) {
          if (item.type == 'image') {
            height = item.height / multiple
          } else {
            height = Math.ceil(item.height / multiple)
          }
        }
        return {
          x,
          y,
          width,
          height,
        }
      },

      // 获取图片宽高
      getImageSize(filePath) {
        return new Promise((resolve, reject) => {
          try {
            let image = new Image()
            image.onload = function () {
              resolve({ width: this.width, height: this.height })
              this.removeAttribute('src')
              image = null
            }
            image.onerror = error => {
              reject(error)
              image = null
            }
            image.src = filePath
          } catch (error) {
            reject(error)
          }
        })
      },
      // 改变大小
      onResize(e, index, type) {
        this.apiData.fields[index].width = Math.ceil(e.width)
        this.apiData.fields[index].height = Math.ceil(e.height)
      },
      // 拖拽
      onDrag(e, index, type) {
        console.log(111)
        this.apiData.fields[index].x = Math.ceil(e.left)
        this.apiData.fields[index].y = Math.ceil(e.top)
      },
      // 提交信息
      submitFn() {
        this.$store.commit('setSpinShow', true)
        let multiple = this.diyData.multiple
        if (this.apiData.template_path == '') return this.$Message.error('请上传证书模板')
        apiCertificates
          .apiCertificatesTempUpdate(this.query.id, {
            fields: this.apiData.fields.map(item => {
              return {
                ...item,
                x: Math.ceil(item.x * multiple),
                y:
                  item.type == 'text'
                    ? Math.ceil((item.y + Number(item.font_size)) * multiple)
                    : Math.ceil(item.y * multiple),
                width: Math.ceil(item.width * multiple),
                height: Math.ceil(item.height * multiple),
                font_size: Math.ceil(Number(item.font_size) * multiple),
              }
            }),
            template_path: this.apiData.template_path,
            template_url: this.apiData.template_url,
          })
          .then(res => {
            this.$Message.success('证书模板编辑成功')
            this.$router.go(-1)
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
    },
    mounted() {
      this.query = this.$route.query
      this.getDetail()
    },
  }
</script>

<style scoped lang="less">
  .license-template {
    display: flex;
    justify-content: left;
    .img-wrap {
      width: 840px;
      border: 1px solid #ededed;
      padding: 20px;
      overflow-y: auto;
      .img {
        position: relative;
        width: 800px;
        background-size: contain;
        margin-bottom: 10px;
        .item {
          position: absolute;
          color: red;
          cursor: pointer;
        }
        .img-item {
          background-color: red;
        }
      }
    }
    .right {
      padding: 0 40px 40px;
      overflow-y: auto;
      .item {
        margin-bottom: 10px;
        .item-title {
          display: flex;
          align-items: center;
          h3 {
            margin-right: 20px;
          }
        }
      }
    }
  }
</style>
